import { AppLayout } from '@src/components/sco/AppLayout';
import { AppLayoutPanelProps } from '@src/components/sco/AppLayout/Panel';
import { MembersNav } from '@src/components/sco/Members/MembersLayout/MembersNav';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';
import React, { useMemo } from 'react';
type MembersLayoutProps = {
  asidePanel?: ReactNode;
  mainPanel?: ReactNode;
  navPanel?: ReactNode;
};
export const MembersLayout = (props: MembersLayoutProps) => {
  const pathname = usePathname();
  const panels: AppLayoutPanelProps[] = useMemo(() => [{
    id: 'members-nav',
    useDrawerBreakpoints: {
      base: true,
      md: false
    },
    isResizable: true,
    resizeHandlePosition: 'right',
    defaultWidth: 280,
    children: props.navPanel ? props.navPanel : <MembersNav />,
    isPanelOpen: true,
    isDrawerOpen: false
  }, {
    id: 'members-main',
    children: props.mainPanel,
    isPanelOpen: true,
    isDrawerOpen: true
  }, {
    id: 'members-aside',
    useDrawerBreakpoints: {
      base: true,
      lg: false
    },
    isResizable: true,
    resizeHandlePosition: 'left',
    drawerPlacement: 'right',
    defaultWidth: 400,
    children: props.asidePanel,
    isPanelOpen: false,
    isDrawerOpen: false
  }], [pathname, props.mainPanel, props.asidePanel]);
  return <AppLayout header={<ScoSiteNavBar />} id={'members-layout'} panels={panels} />;
};
export const MembersPage = Component => {
  Component.getLayout = (page: React.ReactElement) => {
    return <MembersLayout mainPanel={page} />;
  };
  return Component;
};